module.exports = __webpack_public_path__ + "img/co-investing-4.3f89b1da.png";